import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeDeleteMedia = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/media/change-delete`, params);
};